import { render, staticRenderFns } from "./SubmissionAddSteps.vue?vue&type=template&id=6e2fa6ca"
import script from "./SubmissionAddSteps.vue?vue&type=script&lang=js"
export * from "./SubmissionAddSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports